import { createContext, FC, useContext, useState, useCallback } from 'react'
import {
  initialQueryRequest,
  QueryRequestContextProps,
  QueryState,
  WithChildren,
} from '../../../../../../_metronic/helpers'

const QueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

export const QueryRequestProvider: FC<WithChildren> = ({ children }) => {
  const initialState: QueryState = {
    ...initialQueryRequest.state,
    fixedSort: [{ field: 'nomeFantasia', order: 'asc' }],
    search: 'superior:null',
  }
  const [state, setState] = useState<QueryState>(initialState)

  const updateState = useCallback((updates: Partial<QueryState>) => {
    setState((prev) => ({
      ...prev,
      ...updates,
      search:
        'search' in updates
          ? ['superior:null', updates.search].filter(Boolean).join(',')
          : prev.search,
    }))
  }, [])

  return (
    <QueryRequestContext.Provider value={{ state, updateState }}>
      {children}
    </QueryRequestContext.Provider>
  )
}

export const useQueryRequest = () => useContext(QueryRequestContext)
